import PropTypes from 'prop-types';
import React from 'react';
import 'commons-vehicle/Vehicle/components/CallToAction/ThirdParties/Eshop/EshopCTA.scss';

const EshopCTA = ({ serialNo, dealerCode, newVehicle, lang, extraClass }) => {
    if (!serialNo || !dealerCode || !lang) return null;
    return (
        <div className={`${'eshop-cta'} ${extraClass}`}>
            <app-eshop
                vin={serialNo}
                dealercode={dealerCode}
                vehicletype={newVehicle ? 'New' : 'preowned'}
                page="TradeIn"
                language={lang.toUpperCase()}
                onClick="event.stopPropagation()"
            />
        </div>
    );
};

EshopCTA.defaultProps = {
    serialNo: '',
    dealerCode: '',
    newVehicle: false,
    lang: 'en',
    extraClass: '',
};

EshopCTA.propTypes = {
    serialNo: PropTypes.string,
    dealerCode: PropTypes.string,
    newVehicle: PropTypes.bool,
    lang: PropTypes.string,
    extraClass: PropTypes.string,
};

EshopCTA.displayName = 'EshopCTA';

export default EshopCTA;
